import InputField from './components/InputField'
import SelectField from './components/SelectField'

// These will be available from the sidebar
export const fields = [
  {
    type: 'input',
    title: 'Text Input',
    component: InputField,
  },
  {
    type: 'select',
    title: 'Select',
    component: SelectField,
  },
]
